import axiosMiddleware from "./axiosMiddleware";

export const getVirtualCardsListAPI = ({ limit, offset, from, to, agent }) => {
  return axiosMiddleware({
    method: "get",
    url: `/cards/list/virtual?limit=${limit}&offset=${offset}&agentId=${agent}&from=${from}&to=${to}`,
  });
};
export const getPhysicalCardsListAPI = ({ limit, offset, from, to, agent }) => {
  return axiosMiddleware({
    method: "get",
    url: `/cards/list/physical?limit=${limit}&offset=${offset}&agentId=${agent}&from=${from}&to=${to}`,
  });
};
export const getCardsLimitsAPI = (cardId) => {
  return axiosMiddleware({
    method: "post",
    url: "/card/get-limits",
    data: {
      cardId,
    },
  });
};
export const setCardsLimitsAPI = (data) => {
  return axiosMiddleware({
    method: "post",
    url: "/card/set-limits",
    data,
  });
};
export const updateCardsStatusAPI = (data) => {
  return axiosMiddleware({
    method: "post",
    url: "/card/update-status",
    data,
  });
};
export const getCardsStatusAPI = (cardId) => {
  return axiosMiddleware({
    method: "post",
    url: "/card/get-status",
    data: {
      cardId,
    },
  });
};

export const createCreditCardApi = ({
  currency,
  amount,
  email,
  english_first_name,
  persian_first_name,
  english_last_name,
  persian_last_name,
}) => {
  let postData = {
    currency_id: currency,
    amount,
    email,
    english_first_name,
    persian_first_name,
    english_last_name,
    persian_last_name,
  };
  return axiosMiddleware({
    method: "post",
    url: "card/create",
    data: postData,
  });
};
export const createPhysicalCardApi = ({
  currency,
  agent,
  amount,
  email,
  english_first_name,
  persian_first_name,
  english_last_name,
  persian_last_name,
  card_number,
  cvv2,
  expire_date,
}) => {
  let postData = {
    currency_id: currency,
    agent_id: agent,
    amount,
    email,
    english_first_name,
    persian_first_name,
    english_last_name,
    persian_last_name,
    card_number,
    cvv2,
    expire_date,
  };
  return axiosMiddleware({
    method: "post",
    url: "/card/create-physical",
    data: postData,
  });
};
export const topupCardApi = ({ email, currencyId, amount }) => {
  let postData = {
    email,
    currency_id: currencyId,
    amount: Number(amount).toFixed(2),
  };
  return axiosMiddleware({
    method: "post",
    url: "card/topup",
    data: postData,
  });
};
export const sendEmailApi = ({ cardId }) => {
  return axiosMiddleware({
    method: "get",
    url: `/card/resend-email/${cardId}`,
  });
};

export const updateTopupCardStatusApi = ({ reference_number, isCharged }) => {
  let postData = {
    reference_number,
    is_charged: isCharged,
  };
  return axiosMiddleware({
    method: "post",
    url: "/update/topup-card/status",
    data: postData,
  });
};

export const addCardApi = ({ email }) => {
  let postData = {
    email,
  };
  return axiosMiddleware({
    method: "post",
    url: "card/add-card",
    data: postData,
  });
};

export const getCardBalancesAPI = ({ email }) => {
  let postData = {
    email,
  };
  return axiosMiddleware({
    method: "post",
    url: "card/balance",
    data: postData,
  });
};
